import { message } from 'antd';
import { useEffect, useState } from 'react';

import { usePartial } from '@/hooks/usePartial';

import { getDistributionCode } from '../../service';

// 分销码查询类型
export type DistributionQueryType = 1 | 2; // 1查询自己的分销码，2查询绑定的分销码

// 分佣模式类型
// 1固定金额 2固定比例 3走商品
export enum Mode {
  FIXED_AMOUNT = 1,
  FIXED_RATIO = 2,
  PRODUCT_MODE = 3,
}

// 分销码状态
// 0正常 1停用
export enum CodeState {
  Enable = 0,
  Disable = 1,
}

// 单个商品的分佣配置
export interface ProceedsDiscountItem {
  commodityCode: string; // 商品编码
  proceedsRatio: number; // 分佣比例
  proceedsAmount: number; // 分佣金额
  proceedsMode: Mode; // 分佣模式
}

// 单个商品的优惠配置
export interface CommodityDiscountItem {
  commodityCode: string; // 商品编码
  discount: number; // 优惠比例
  discountAmount: number; // 优惠金额
  discountMode: Mode; // 优惠模式
}

// 分销码相关数据
export interface DistributionCodeData {
  type?: DistributionQueryType; // 查询类型
  distributionCode?: string; // 分销码
  proceedsRatio?: number; // 收益分成比例
  proceedsAmount?: number; // 收益分成金额
  proceedsMode?: Mode; // 分佣模式
  proceedsDiscount?: ProceedsDiscountItem[]; // 多商品分佣配置
  discount?: number; // 优惠比例
  discountAmount?: number; // 优惠金额
  discountMode?: Mode; // 优惠模式
  commodityDiscount?: CommodityDiscountItem[]; // 多商品优惠配置
  codeState?: CodeState; // 分销码状态

  inviteUrl?: string; // 邀请链接
  pattern?: string | number; // 分销码模式
}

export interface InviteInfo extends DistributionCodeData {
  isInvited: boolean;
}

export function useDistributionCode() {
  const [loading, setLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [inviteInfo, setInviteInfo] = usePartial<InviteInfo>({
    isInvited: false,
  });

  const getCode = async () => {
    try {
      setLoading(true);
      const res = await getDistributionCode<DistributionCodeData>(1);
      if (res.success) {
        if (res.data && !Array.isArray(res.data)) {
          setInviteInfo({
            ...res.data,
            isInvited: res.data.pattern === 2 ? true : false,
          });
        }
      } else {
        message.error(res.message);
      }
    } catch (error) {
      console.error('获取分销码失败:', error);
    } finally {
      setLoading(false);
    }
  };

  const inviteUrl =
    window.location.origin + '/home?inviteCode=' + inviteInfo.distributionCode;

  const copyUrl = () => {
    if (inviteInfo?.distributionCode && inviteInfo?.pattern) {
      navigator.clipboard.writeText(inviteUrl);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);
    }
  };

  useEffect(() => {
    getCode();
  }, []);

  return {
    loading,
    inviteInfo,
    setInviteInfo,
    isCopied,
    copyUrl,
    inviteUrl,
  };
}
